import React from 'react';
import { Typography } from '@mui/material';
import styles from '../styles/LessonPointsView.module.css';

interface LessonPointsViewProps {
  points: number;
  assigned: number;
  showPercentage?: boolean;
}

export function LessonPointsView(props: LessonPointsViewProps) {
  if (!props.assigned) return null;

  const numOfpercentage = Math.round((props.points / props.assigned) * 100);

  return (
    <Typography className={styles.feedbackText} variant="caption">
      <span className={styles.feedbackPoints}>{props.points ?? 0}</span>{' '}
      {`out of ${props.assigned} point${props.assigned !== 1 ? 's' : ''} ${
        props.showPercentage ? `(${numOfpercentage}%)` : ''
      }`}
    </Typography>
  );
}
